import { GuiService } from 'src/app/services/gui.service';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { RestService } from 'src/app/services/rest.service';
import { TranslateService } from '@ngx-translate/core';
declare var require: any;
const htmlToPdfmake = require("html-to-pdfmake");
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'vex-survey-admin',
  templateUrl: './survey-admin.component.html',
  styleUrls: ['./survey-admin.component.scss']
})
export class SurveyAdminComponent implements OnInit {
  mySurvey: any;
  questFormGroup: UntypedFormGroup;
  surveyFormGroup: UntypedFormGroup;
  icon = {
    "download": faDownload
  }

  unit: string;

  @ViewChild('pdfTable')
  pdfTable!: ElementRef;

  @ViewChild('pdfTable1')
  pdfTable1!: ElementRef;
  measurements: any = [];
  rows: any = [];

  constructor(private dialogRef: MatDialogRef<SurveyAdminComponent>,@Inject(MAT_DIALOG_DATA) private item: any['item'], private fb: FormBuilder, public guiService: GuiService, private restService: RestService, public translate: TranslateService) { }

  ngOnInit(): void {
    if (this.guiService.userLogged) {
      this.mySurvey = this.item;
      this.setRows(this.item.unitSystem)
      this.getMeasurements(this.item.userId);
      this.unit = this.mySurvey.unitSystem;

      this.questFormGroup = this.fb.group({
        nome: [this.item.name],
        cognome: [this.item.surname],
        eta: [this.item.age],
        altezza: [this.item.height],
        peso: [this.item.weight],
        vita: [this.item.weistline],
        fianchi: [this.item.hip],
        coscia_dx: [this.item.leftThigh],
        coscia_sx: [this.item.rightThigh],
        braccio_dx: [this.item.leftArm],
        braccio_sx: [this.item.rightArm],
        attivita: [this.item.activity],
        stile: [this.item.lifeStyle],
        ciclo: [this.item.period],
        frequenza_ciclo: [this.item.periodFrequency],
        patologie: [this.item.pathologies],
        terapia: [this.item.therapy],
        allergie: [this.item.allergies],
        consideration: [this.item.consideration]
      });

      this.surveyFormGroup = this.fb.group({
        peso: [this.item.weight],
        vita: [this.item.weistline],
        fianchi: [this.item.hip],
        coscia_dx: [this.item.leftThigh],
        coscia_sx: [this.item.rightThigh],
        braccio_dx: [this.item.leftArm],
        braccio_sx: [this.item.rightArm],
        like: [this.item.like],
        dislike: [this.item.dislike],
        would: [this.item.would],
        consideration: [this.item.consideration]
      });
    } else {
      this.getCurrent();
    }
  }

  setRows(unitSystem){
    this.rows = [
      { label: this.translate.instant("USER-NUTRITION.SURVEY_C."+unitSystem+'.WEIGHT'), key: 'weight' },
      { label: this.translate.instant("USER-NUTRITION.SURVEY_C."+unitSystem+'.WAIST'), key: 'weistline' },
      { label: this.translate.instant("USER-NUTRITION.SURVEY_C."+unitSystem+'.FLANKS'), key: 'hip' },
      { label: this.translate.instant("USER-NUTRITION.SURVEY_C."+unitSystem+'.ARM_SX'), key: 'leftArm' },
      { label: this.translate.instant("USER-NUTRITION.SURVEY_C."+unitSystem+'.ARM_DX'), key: 'rightArm' },
      { label: this.translate.instant("USER-NUTRITION.SURVEY_C."+unitSystem+'.THIGH_DX'), key: 'rightThigh' },
      { label: this.translate.instant("USER-NUTRITION.SURVEY_C."+unitSystem+'.THIGH_SX'), key: 'leftThigh' }
    ];
  }

  getCurrent() {
    setTimeout(()=>this.guiService.showSpinner = true,0);
    this.restService.getService('current_user', '').subscribe((ris) => {
      this.guiService.userLogged = ris;
      this.guiService.showSpinner = false;
      this.ngOnInit();
    })
  }

  public downloadSurveyAsPDF() {
    let pdfTable
    if(this.mySurvey.surveyType == 'questionario'){
      pdfTable = this.pdfTable.nativeElement;
    }if(this.mySurvey.surveyType == 'follow-up'){
      pdfTable = this.pdfTable1.nativeElement;
    }

    var html = htmlToPdfmake(pdfTable.innerHTML);
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download();
  }

  closeDialog(){
    this.dialogRef.close('true')
  }

  getMeasurements(userIdParam: string){
    setTimeout(()=>this.guiService.showSpinner = true,0);
    this.restService.postService('node','/get-user-surveys-admin', {userId: userIdParam, adminId: this.guiService.userLogged.user.id}).subscribe((ris)=>{
      this.measurements = ris.sort((a, b) => {
        const timeA = new Date(a.creationDate).getTime();
        const timeB = new Date(b.creationDate).getTime();
        return timeB - timeA;
      }).slice(0, 6);
      this.measurements.forEach((s) => {
        if (s?.extraInfo?.newDecimaleMode) {
          this.normalizeMeasurements(s);
        }
      });
     console.debug('measurements',this.measurements);
     this.guiService.showSpinner = false;
    })
  }

  normalizeMeasurements(obj: any): any {
    const fieldsToConvert = [
      "weight",
      "height",
      "weistline",
      "hip",
      "rightThigh",
      "leftThigh",
      "rightArm",
      "leftArm",
    ];

    fieldsToConvert.forEach((field) => {
      if (obj[field] !== null && obj[field] !== undefined) {
        const numericValue = parseInt(String(obj[field]), 10);
        if (!isNaN(numericValue)) {
          obj[field] = Math.round(numericValue) / 100;
        }
      }
    });

    return obj;
  }

}
